import { APP_STORE_URL, PLAY_STORE_URL } from "../../lib/appLinks";
import { useLocalization } from "../../lib/i18n";

type StoreBadgesProps = {
  className?: string;
  variant?: "row" | "stack";
};

const badgeLocaleByAppLocale: Record<string, "en" | "fr" | "ja"> = {
  en: "en",
  fr: "fr",
  ja: "ja",
};

function getBadgeLocale(locale: string) {
  return badgeLocaleByAppLocale[locale] ?? "en";
}

export function getStoreBadgeAssets(locale: string) {
  const badgeLocale = getBadgeLocale(locale);

  return {
    appStore: `/img/store-badges/app-store-${badgeLocale}.svg`,
    googlePlay: `/img/store-badges/google-play-${badgeLocale}.svg`,
  };
}

export function StoreBadges({ className = "", variant = "row" }: StoreBadgesProps) {
  const { locale, t } = useLocalization();
  const badges = getStoreBadgeAssets(locale);
  const layoutClass = variant === "stack" ? "flex-col items-start" : "flex-row flex-wrap items-center";

  return (
    <div className={`flex gap-3 ${layoutClass} ${className}`}>
      <a href={APP_STORE_URL} target="_blank" rel="noreferrer" aria-label={t("guest.auth.appStore")}>
        <img
          src={badges.appStore}
          alt={t("guest.auth.appStore")}
          className="h-10 w-auto max-w-full object-contain"
          loading="lazy"
        />
      </a>
      <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer" aria-label={t("guest.auth.playStore")}>
        <img
          src={badges.googlePlay}
          alt={t("guest.auth.playStore")}
          className="h-10 w-auto max-w-full object-contain"
          loading="lazy"
        />
      </a>
    </div>
  );
}
